/*eslint-disable*/
import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import styles from "assets/jss/llv/components/footerStyle.js";

const useStyles = makeStyles(styles);

export default function Footer(props) {
  const classes = useStyles();
  return (
    <footer className={classes.footer}>
      <div className={classes.container}>
        <p className={classes.right}>
          <span>
            &copy; 2019 - {1900 + new Date().getYear()}{" "}
            <a
              href="https://yakoafricassur.com"
              target="_blank"
              className={classes.a}
            >
              YAKO AFRICA ASSURANCE VIE
            </a>
            
          </span>
        </p>
      </div>
    </footer>
  );
}
